import * as React from "react";
import {
  Dropdown,
  IDropdownOption,
} from "@fluentui/react/lib/Dropdown";
import RbLabel from "../../../bosch-react/components/label/RbLabel";
import _ from "lodash";
import axios from "axios";
import { ProgressIndicator } from "@fluentui/react/lib/ProgressIndicator";

interface IProps {
  countries: any,
  onChange: any,
  isLoading: boolean
}

class Experts_Refinement_Country extends React.Component<
  IProps,
  any
> {
  //public options: any[] = [];
  constructor(props: any) {
    super(props);
    this.state = {
      IsShown: false,
      Countries: [{ key: "None", text: "--- All ---" }],
      SelectedCountry: "None",
      isClickToRemove: false,
      foundAfterFilter: 0,
    };
    //this.handleSearch = this.handleSearch.bind(this);
    this.onChange = this.onChange.bind(this);
  }
  retrieveFilterOptions = () => {
    //Validate asterisk char because search all will be get 504 error
    const countriesObj: any[] = [];
    const countries = this.props.countries;
    Object.getOwnPropertyNames(countries).forEach((country: string) => {
      country !== "None" &&
        countriesObj.push({
          key: country,
          text: country,
          data: countries[`${country}`],
        });
    });
    countriesObj.unshift({ key: "None", text: "--- All ---" });
    this.setState({
      Countries: countriesObj,
      SelectedCountry: "None",
      isLoading: false,
    });
  };
  componentDidMount(): void { }

  render() {
    let element = (
      <div className="ms-Grid" style={{ marginBottom: "1.5rem" }}>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <RbLabel hasPadding={true}>Countries</RbLabel>
            {this.props.isLoading ? (
              <ProgressIndicator label="Searching..." />
            ) : (
              <Dropdown
                selectedKey={this.state.SelectedCountry}
                options={this.state.Countries}
                onChange={(event, item) => this.onChange(event, item)}
              />
            )}
          </div>
        </div>
      </div>
    );
    return element;
  }

  onChange = (
    event: React.FormEvent<HTMLDivElement>,
    item: IDropdownOption | undefined
  ): void => {
    this.props.onChange(item)
  };
}

export default Experts_Refinement_Country;
